<script setup>
import { ref } from 'vue';
import { useBackend } from '@/composables/Backend';

const backend = useBackend();
const isLoading = ref(false);
const error = ref('');

// const email = ref('');
// const router = useRouter();

// const doLogin = async (username, onSuccess, onError) => {
//   try {

//     backend.login({email: username}).then(result => {
//       if (result == false || result.error) {
//         var error = result.error;
//         if (!error) {
//           error = 'An error occurred communicating with the API.';
//         }
//         error = `Error updating shopping cart item: ${error}`;        
//       }
//       else {
//         if (result.redirectUrl) {
//             window.location.href = result.redirectUrl;
//         } else {
//             if (onError) {
//                 onError('No redirect URL returned');
//             }
//         }
//       }
//     }); 
//   } catch (err) {
//     if (onError) {
//       onError(err.message || 'Login request failed');
//     }
//   }
// };

// Export for useCurrentUser composable
// defineExpose({ doLogin });

async function handleLogin() {
  isLoading.value = true;
  error.value = '';
  try {
    backend.login().then(result => {
      if (result == false || result.error) {
        var error = result.error;
        if (!error) {
          error = 'An error occurred communicating with the API.';
        }
        error = `Error updating shopping cart item: ${error}`;        
      }
      else {
        if (result.redirectUrl) {
          window.location.href = result.redirectUrl;
        } else {
          if (error) {
            console.log('No redirect URL returned');
          }
        }
      }
    });
  } catch (err) {
    error.value = err.message;
  } finally {
    isLoading.value = false;
  }
}
</script>

<template>
  <div class="container my-account">
    <div class="row section--login">
      <div class="col">
        <h2>Welcome back!</h2>
        <div class="dashed-divider"></div>
        <p class="no--margin-b">
            Sign in or sign up today for:
        </p>
        <h3 class="regular no--margin-b">
          - A faster checkout experience<br />
          - Order status and history<br />
          - Easy access to custom quotes<br />
        </h3>
      </div>
      <div class="col">
        <div class="">
          <h3>Sign in with Email</h3>
          <button class="button primary__btn col--1-of-4" :disabled="isLoading" @click="handleLogin">
            {{ isLoading ? 'Loading...' : 'Sign In →' }}
          </button>

          <h3 style="margin-top: 24px;">Create an Account</h3>
          <button class="button primary__btn col--1-of-4" :disabled="isLoading" @click="handleLogin">
            {{ isLoading ? 'Loading...' : 'Sign Up →' }}
          </button>
          <!-- <p v-if="error" class="error">{{ error }}</p>
          <button class="button col--1-of-4 first" type="submit">
            Sign In →
          </button> -->
          <div v-if="error" class="alert alert-danger">{{ error }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// function handleSuccess(data) {
//   // Not called here—redirect happens instead
//   console.log('Success callback placeholder:', data);
// }

// function handleError(errorMsg) {
//   error.value = errorMsg;
// }
</script>